import { createSelector } from 'reselect'
import convertToDatetime from '../utility/convertToDatetime'

const getTimestamp = state => {
  return state.timeSlider.value
}

const getFormatter = (state, formatter) => {
  return formatter || (value => value)
}

export const makeGetTimesliderDatetime = () => {
  return createSelector(
    [getTimestamp, getFormatter],
    (timestamp, formatter) => {
      if (timestamp) {
        return formatter(convertToDatetime(timestamp))
      } else {
        return null
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/selectors/timesliderDatetimeSelector.js